/**
 * Custom Mandir Popup & Alert System
 * Intercepts window.alert and provides custom spiritual modal popups
 */

let listeners = [];
let pendingQueue = [];

export const subscribePopup = (callback) => {
  listeners.push(callback);
  // Flush any queued alerts that occurred before mounting
  if (pendingQueue.length > 0) {
    const queueToFlush = [...pendingQueue];
    pendingQueue = [];
    queueToFlush.forEach((item) => callback(item));
  }
  return () => {
    listeners = listeners.filter((l) => l !== callback);
  };
};

export const showCustomPopup = ({
  title,
  message,
  type = "info",
  confirmText = "OK",
  cancelText = null,
  onConfirm = null,
  onCancel = null,
}) => {
  const payload = {
    id: Date.now() + Math.random(),
    title,
    message: String(message || ""),
    type,
    confirmText,
    cancelText,
    onConfirm,
    onCancel,
  };

  if (listeners.length > 0) {
    listeners.forEach((listener) => listener(payload));
  } else {
    pendingQueue.push(payload);
  }
};

/**
 * Intelligent helper to infer type and title from alert message
 */
export const showCustomAlert = (rawMessage) => {
  const msg = String(rawMessage || "");
  let type = "info";
  let title = "Sri Gnana Sai Baba Mandir";

  const lower = msg.toLowerCase();
  if (
    msg.includes("🎉") ||
    msg.includes("🙏") ||
    lower.includes("success") ||
    lower.includes("approved") ||
    lower.includes("thank") ||
    lower.includes("saved")
  ) {
    type = "success";
    if (lower.includes("donation") || lower.includes("contribut")) {
      title = "Sacred Offering Received";
    } else if (lower.includes("status") || lower.includes("approved")) {
      title = "Status Updated Successfully";
    } else if (lower.includes("saved") || lower.includes("updated")) {
      title = "Changes Saved";
    } else {
      title = "Om Sai Ram 🙏";
    }
  } else if (
    msg.includes("❌") ||
    lower.includes("error") ||
    lower.includes("failed") ||
    lower.includes("fail")
  ) {
    type = "error";
    title = "Notice";
  } else if (
    lower.includes("please") ||
    lower.includes("required") ||
    lower.includes("match") ||
    lower.includes("invalid")
  ) {
    type = "warning";
    title = "Action Required";
  }

  showCustomPopup({
    title,
    message: msg,
    type,
    confirmText: "OK",
  });
};

export const showCustomConfirm = ({
  title = "Confirm Action",
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  onConfirm,
  onCancel,
}) => {
  showCustomPopup({
    title,
    message,
    type: "confirm",
    confirmText,
    cancelText,
    onConfirm,
    onCancel,
  });
};

// Global interceptor for window.alert so ALL alerts in entire app use this UI automatically
if (typeof window !== "undefined") {
  window.alert = (msg) => {
    showCustomAlert(msg);
  };
  window.customAlert = showCustomAlert;
  window.customConfirm = showCustomConfirm;
}
